type PublicDependenciesState = {
  slug?: string | null;
  loading: boolean;
  hasEstablishment: boolean;
  hasPublicAccessError: boolean;
};

export function shouldLoadPublicDependencies(state: PublicDependenciesState): boolean {
  if (!state.slug || state.loading) return false;
  return state.hasEstablishment || state.hasPublicAccessError;
}
